import React from "react";
import { IdentityApplicationViewState } from "libs/resources/identity/applications/application-views/IdentityApplicationInfo";
import { Container, Box } from "@material-ui/core";
import { ApplicationRemover } from "./ApplicationRemover";
import { AppConfiguration } from "pages/home/apis/components/ApiConfiguration";
import { IdentityApplication } from "../../services/ApplicationService";
import { ResourceAuthorizer } from "pages/home/authorizer/components/Authorizer";

interface ApplicationOverviewTabProps {
  state: IdentityApplicationViewState; 
}

const ApplicationOverviewTab: React.FC<ApplicationOverviewTabProps> = ({ state }) => {


  
  return (
    <Container maxWidth={false} style={{ padding: "0px" }}>
      <Box>
      {state.application && (<AppConfiguration application={state.application}/>)}
      </Box>
      
      <Box style={{paddingTop: "20px", display: 'flex', justifyContent: 'flex-end'}}>
      {state?.application?.applicationId && (
        <ResourceAuthorizer
            action="delete"
            resourceType="APPLICATION"
            resourceId={state.application.applicationId as string}
            hideErrorMessage
          >
            <ApplicationRemover application={state.application as IdentityApplication}/>
          </ResourceAuthorizer>
      )}
      </Box>
    </Container>
  );
};

export default ApplicationOverviewTab;
